export const environment = {
    production: false,
    baseApi:'https://whatzmeapi-apichat.tgconsulting.online/api',
    baseWebSocket:'https://whatzmeapi-apichat.tgconsulting.online/stomp',
    baseTopic:'/user/queue',
};